import { useParams } from "react-router-dom";
import InfoColeccion from "./info_coleccion";
import Twitter_icon from "../../../assets/images/svg/twitter_icon.svg";
import Facebook_icon from "../../../assets/images/svg/facebook_icon.svg";
import Link_icon from "../../../assets/images/svg/link_icon.svg";
import BreadCrumb from "./breadcrumb";
import { useEffect, useState } from "react";
import { webApiColeccionDetalle } from "../../../routes/endpoints";
import axios from "axios";
import { coleccionesDTO } from "../../../models/Colecciones.model";
import { base_url_completa, base_url_completa_codificada } from "../../../constants";
import ListadoGenerico from "../../../utilities/ListadoGenerico/principal";
import Loading from "../../../utilities/Loading";
import Alertas from "../../../utilities/Alertas";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { PlecaMorada } from "../../../utilities/PlecaMorada";

export default function Main(){
    const { id } = useParams() as { id: any; }
    const [infoColeccion, setInfoColeccion] = useState<coleccionesDTO[]>([]);    
    useEffect(()=>{
        window.scrollTo(0, 0)
        axios.post(webApiColeccionDetalle, {id: id} ).then((response) => {
            setInfoColeccion(response.data);            
        }).catch(err => console.warn(err)); 
    },[id]); 
    if(infoColeccion?.length){   
        return(
        <>
            <BreadCrumb titulo={Object.values(infoColeccion)[0].titulo} url="colecciones"/>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-11">
                        <div className="row">
                            <InfoColeccion imagen={Object.values(infoColeccion)[0].imagen} titulo={Object.values(infoColeccion)[0].titulo} descripcion={Object.values(infoColeccion)[0].descripcion}/>
                            <div className="row px-0">                            
                                <div
                                    className="col-12 d-flex mt-2 justify-content-center justify-content-md-end align-items-center px-0">
                                    <div className="text-center">
                                        <p className="mb-1">Compartir en:</p>
                                        <a href={`https://twitter.com/intent/tweet?text=Revisa la obra compartida a través del sitio Editorial&url=${base_url_completa_codificada}%2Fcolecciones%2F${id}&lang=es&via=TEPJF_informa`} target="_blank"><img alt="icon_twitter" src={Twitter_icon} className="icon_socialmedia"/></a>
                                        <a href={`http://www.facebook.com/sharer.php?u=${base_url_completa}/colecciones/${id}`} target="_blank" rel="noopener noreferrer"><img alt="icon_facebook" src={Facebook_icon} className="icon_socialmedia"/></a>
                                        <CopyToClipboard text={`${base_url_completa}/colecciones/${id}`}> 
                                            <img alt="icon_copiado" role="button" src={Link_icon} className="icon_socialmedia" onClick={ () =>Alertas('Ruta copiada correctamente')}/>                                   
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ListadoGenerico id={id} pagina={0} seccion={2}/>
            <PlecaMorada/>
        </>
        )           
    }else{  
        return(
            <Loading/>
        ) 
    }
}
